// -----------------------
// <auto-generated>
// Generated using the script normalizrSchemaGenerator.js
// </auto-generated>
// -----------------------
import { schema } from 'normalizr';
import { ObjectsWithoutIdPropertyEnum } from './SgmSearchApiSchemaTypes';
import { BaseSgmSearchApiSchema } from './BaseSgmSearchApiSchema';

export { ObjectsWithoutIdPropertyEnum } from './SgmSearchApiSchemaTypes';
export type { ObjectsWithoutIdProperty } from './SgmSearchApiSchemaTypes';

export interface ISgmSearchEntities {
    categories?: Record<string, unknown>;
    servicePages?: Record<string, unknown>;
    sgmServices?: Record<string, unknown>;
    subcategories?: Record<string, unknown>;
}

export class SgmSearchApiSchema extends BaseSgmSearchApiSchema {
    public static CategorySchema = new schema.Entity(
        'categories',
        {},
        {
            idAttribute: (value: any) => SgmSearchApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.Category),
        });
    public static ServicePageSchema = new schema.Entity(
        'servicePages',
        {},
        {
            idAttribute: 'id',
        });
    public static SgmServiceSchema = new schema.Entity(
        'sgmServices',
        {},
        {
            idAttribute: (value: any) => SgmSearchApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.SgmService),
        });
    public static SubcategorySchema = new schema.Entity(
        'subcategories',
        {},
        {
            idAttribute: (value: any) => SgmSearchApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.Subcategory),
        });

    public static CategorySchemaArray = new schema.Array(SgmSearchApiSchema.CategorySchema);
    public static ServicePageSchemaArray = new schema.Array(SgmSearchApiSchema.ServicePageSchema);
    public static SgmServiceSchemaArray = new schema.Array(SgmSearchApiSchema.SgmServiceSchema);
    public static SubcategorySchemaArray = new schema.Array(SgmSearchApiSchema.SubcategorySchema);

    public static initialize(): void {
        SgmSearchApiSchema.CategorySchema.define({
            subcategories: SgmSearchApiSchema.SubcategorySchemaArray,
        });

        SgmSearchApiSchema.SgmServiceSchema.define({
            servicePages: SgmSearchApiSchema.ServicePageSchemaArray,
        });
    }
}

SgmSearchApiSchema.initialize();
